import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/analytics";

const AnalyticsRouteTracker = () => {
  const location = useLocation();
  const lastPathRef = useRef("");

  useEffect(() => {
    const path = `${location.pathname}${location.search || ""}`;
    if (path === lastPathRef.current) return;
    lastPathRef.current = path;
    trackPageView(location.pathname, {
      page_path: location.pathname,
    });
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsRouteTracker;
